module.exports = __webpack_public_path__ + "static/6. Exe-cu-tion-5aa014a0aa624a0d384132e5cad8df5b.png";